import { ThemeIcon } from '@src/theme/ThemeIcon';
import type { IconProps } from './IconProps';
export function BellIcon({ className }: IconProps) {
  return (
    <ThemeIcon name="bell" className={className} fallback={
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" />
    </svg>} />
  );
}
